export default __webpack_public_path__ + "static/media/ic_bone_16.121eb274.svg";